var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "no-ssr",
          [
            _c(
              "carousel",
              {
                staticClass: "highlights",
                attrs: {
                  autoplay: true,
                  loop: true,
                  "pagination-enabled": false,
                  "per-page-custom": [
                    [0, 1],
                    [576, 2],
                    [992, 4],
                    [1400, 4]
                  ],
                  speed: 1000,
                  "autoplay-timeout": 5000
                }
              },
              [
                _c("slide", [
                  _c(
                    "div",
                    { staticClass: "highlight highlight--delivery" },
                    [
                      _c("cms-block-chunk", {
                        attrs: {
                          identifier: "c_CERTYFIKOWANA_JAKOSC",
                          "default-value":
                            '<div class="h3 highlight__title"> </div>'
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("slide", [
                  _c(
                    "div",
                    { staticClass: "highlight highlight--return" },
                    [
                      _c("cms-block-chunk", {
                        attrs: {
                          identifier: "c_BEZTERMINOWA_GWARANCJA",
                          "default-value":
                            '<div class="h3 highlight__title"> </div>'
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("slide", [
                  _c(
                    "div",
                    { staticClass: "highlight highlight--warranty" },
                    [
                      _c("cms-block-chunk", {
                        attrs: {
                          identifier: "c_ZWIEKSZONA_WYDAJNOSC",
                          "default-value":
                            '<div class="h3 highlight__title"> </div>'
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("slide", [
                  _c(
                    "div",
                    { staticClass: "highlight highlight--security" },
                    [
                      _c("cms-block-chunk", {
                        attrs: {
                          identifier: "c_PEWNOSC_BEZPIECZENSTWO",
                          "default-value":
                            '<div class="h3 highlight__title"> </div>'
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }